module.exports = __webpack_public_path__ + "media/images/microsoft-authenticator-b0611c00.png";